import React, { FC } from 'react'
import { ResizeHandle as ResizeHandleType } from '../templateEditor.types'
import styles from './templateEditor__resizeHandle.jcss'

type TemplateEditorResizeHandleProps = {
    handle: ResizeHandleType
    onMouseDown: (event: React.MouseEvent) => void
}

export const TemplateEditorResizeHandle: FC<TemplateEditorResizeHandleProps> = ({ handle, onMouseDown }) => (
    <div className={`${styles.handle} ${styles[handle]}`} onMouseDown={onMouseDown} />
)
